import React from 'react';
import FounderImg from './Found.png'; // Point to your placeholder image

const FounderSection = () => {
  return (
    <section className="bg-[#1a1515] text-white py-24 px-6 md:px-12 lg:px-20 border-t border-neutral-900 overflow-hidden">
      <div className="max-w-5xl mx-auto relative">
        
        {/* Large Translucent Background Text for Luxury Editorial Touch */}
        <div className="absolute -top-10 -left-10 font-serif text-8xl md:text-[12rem] text-neutral-800/10 tracking-tighter select-none pointer-events-none font-bold">
          निर्मिती
        </div>

        <div className="flex flex-col md:flex-row items-center md:items-stretch gap-12 lg:gap-16 relative z-10">
          
          {/* Left Side: Modern Layered Image Frame */}
          <div className="w-full md:w-2/5 flex justify-center items-center">
            <div className="relative group w-64 h-80 md:w-full md:h-full min-h-[360px]">
              
              {/* Decorative Geometric Outline Frame */}
              <div className="absolute -inset-3 border border-amber-500/20 translate-x-2 translate-y-2 transition-transform duration-500 group-hover:translate-x-0 group-hover:translate-y-0"></div>
              
              {/* Solid Background Drop Accent */}
              <div className="absolute inset-0 bg-[#5c1d24]/20 -z-10"></div>
              
              {/* Main Image Container */}
              <div className="w-full h-full overflow-hidden border border-neutral-800 bg-neutral-900 shadow-2xl">
                <img 
                  src={FounderImg} 
                  alt="Palash Dhande, Founder" 
                  className="w-full h-full object-cover object-top grayscale transition-all duration-700 ease-out group-hover:grayscale-0 group-hover:scale-105"
                />
              </div>

              {/* Minimal floating seal tag */}
              <div className="absolute -bottom-4 -right-4 bg-[#5c1d24] text-amber-400 text-[9px] font-semibold tracking-widest uppercase py-2 px-4 shadow-xl border border-amber-500/20">
                Est. 2026
              </div>
            </div>
          </div>

          {/* Right Side: Ultra-Modern Clean Text Blueprint */}
          <div className="w-full md:w-3/5 flex flex-col justify-center space-y-6">
            
            <div className="space-y-2">
              <div className="inline-flex items-center space-x-2">
                <span className="h-[1px] w-6 bg-amber-500"></span>
                <span className="text-[10px] uppercase tracking-widest text-amber-400 font-semibold">
                  सूत्रधार • The Visionary
                </span>
              </div>
              <h3 className="font-serif text-3xl md:text-4xl text-neutral-100 font-light tracking-wide">
                Mrs. Lalita Dhande
              </h3>
              <p className="font-serif text-sm text-amber-600/80 italic tracking-wider">
                Founder & Master Creative Director
              </p>
            </div>

            {/* Premium Justified Copy */}
            <div className="text-sm text-neutral-400 leading-relaxed font-light space-y-4 max-w-xl">
              <p>
                Driven by a vision to immortalize the royal draping patterns of Maharashtra, she established Tuljai Nauvari Boutique to serve as a digital bridge between native artisan handlooms and luxury client experiences. 
              </p>
              <p>
                By fusing historical Maharashtrian design aesthetics with cutting-edge styling precision, she re-imagines legacy silhouettes for the global, modern era, ensuring each drape honors generations of heritage.
              </p>
            </div>

            {/* Custom Modern Signature Quote Element */}
            <div className="pt-4 border-t border-neutral-800/60 max-w-md">
              <p className="font-serif text-xs italic text-neutral-400 leading-relaxed tracking-wide">
                "Tradition is not about preserving the ashes, but passing on the flame."
              </p>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default FounderSection;